import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import { MenuItem as MenuItemProps } from "../../../types/Menu";
import { Box } from "../../Box";
import { Flex } from "../../Flex";
import { Icon } from "../../Icon";
import { MenuItemLink } from "../../MenuItemLink";

interface Props {
  hideArrow?: boolean;
}

export const DesktopMenuDropDownHeader: React.FC<Props & MenuItemProps> = ({ title, url, hideArrow }) => (
  <Flex justifyContent="center" alignItems="center">
    <MenuItemLink to={url} color="white">
      {title}
    </MenuItemLink>
    {hideArrow ? null : (
      <Box pl={2}>
        <Icon color="white" icon={faAngleDown} fontSize={1} />
      </Box>
    )}
  </Flex>
);
